export enum PSUseCoinConditionTypeEnum {
  ALL = 'All',
  STORY = 'STORY',
}

export const promotionSaleCoinConditionValue = {
  [PSUseCoinConditionTypeEnum.ALL]: 'ทั้งหมด',
  [PSUseCoinConditionTypeEnum.STORY]: 'ภายในเรื่องเดียวกัน',
}
